import effectManager from '../module/effect';

let effect = new effectManager();

/* ---------------------------------------

    -- セクションで共通動作

--------------------------------------- */
export default class  SectionManager {
    constructor() {

        this.$target = $(".p-section")

        this.status = {
            1:{
                flg : false,
                show:{
                    timer0:"",
                    timer1:"",
                    timer2:"",
                },
                out:{
                    timer0:"",
                }
            },
            2:{
                flg : false,
                show:{
                    timer0:"",
                    timer1:"",
                    timer2:"",
                },
                out:{
                    timer0:"",
                }
            },
            // 3:{
            //     flg : false,
            //     show:{
            //         timer0:"",
            //         timer1:"",
            //         timer2:"",
            //     },
            //     out:{
            //         timer0:"",
            //     }
            // },
            3:{
                flg : false,
                show:{
                    timer0:"",
                    timer1:"",
                    timer2:"",
                },
                out:{
                    timer0:"",
                }
            }
        }

    }
    init(){


    }

    show(current){
        this.status[current].flg = true;
        let _selectID = this.$target.eq(current).attr("id"),
            _$select = $("#"+_selectID);
        // clearTimeout(this.status[current].out.timer0);
        // TweenMax.set(_$select,{opacity:1});
        this.status[current].show.timer0 = setTimeout(()=>{
            if(_$select.find(".js__svg")[0])effect.svg(_$select.find(".js__svg"),"show");
            if(_$select.find(".js__cover")[0]) effect.cover(!Useragnt.mobile?_$select.find(".js__cover"):_$select.find(".js__cover-sp"),"show")
            this.status[current].show.timer1 = setTimeout(()=>{
                if(_$select.find(".js__line")[0])effect.line(_$select.find(".js__line"),"show")
                if(_$select.find(".js__splittext")[0]) effect.splitText(_$select.find(".js__splittext >* >*"),"show")
                if(_$select.find(".js__show-01__inner")[0])effect.show(_$select.find(".js__show-01__inner"),"show")
            },1e3);
            this.status[current].show.timer2 = setTimeout(()=>{
                if(_$select.find(".js__show__inner")[0])effect.show(_$select.find(".js__show__inner"),"show")
                if(_$select.find(".js__cover")[0]) effect.cover(!Useragnt.mobile?_$select.find(".js__cover"):_$select.find(".js__cover-sp"),"out")
            },15e2);
        },5e2)


        if(current==1) effect.show($("#p-btn-movie .js__show__inner"),"show")

    }
    out(current){
        this.status[current].flg = false;
        let _selectID = this.$target.eq(current).attr("id"),
            _$select = $("#"+_selectID);

        TweenMax.killTweensOf(_$select.find(".js__svg,.js__line,.js__splittext >* >*,.js__show__inner,.js__cover"));
        clearTimeout(this.status[current].show.timer0)
        clearTimeout(this.status[current].show.timer1)
        clearTimeout(this.status[current].show.timer2)
        if(_$select.find(".js__svg")[0])effect.svg(_$select.find(".js__svg"),"out");
        if(_$select.find(".js__line")[0])effect.line(_$select.find(".js__line"),"out")
        if(_$select.find(".js__splittext")[0])effect.splitText(_$select.find(".js__splittext >* >*"),"out")
        if(_$select.find(".js__show-01__inner")[0])effect.show(_$select.find(".js__show-01__inner"),"out")
        if(_$select.find(".js__show__inner")[0])effect.show(_$select.find(".js__show__inner"),"out")
        if(_$select.find(".js__cover")[0])effect.cover(!Useragnt.mobile?_$select.find(".js__cover"):_$select.find(".js__cover-sp"),"out")

        // if(current==3) effect.bgImg($("#p-products-bg .bg"),"out");
    }
    render(mouse,scrollInc){

    }
    resize(){

    }
}